module.exports = __webpack_public_path__ + "static/media/comment-medical.b942583b.svg";